/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lastname1Inputs */

const en_lastname1 = /** @type {(inputs: Lastname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last Name`)
};

const de_lastname1 = /** @type {(inputs: Lastname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nachname`)
};

/**
* | output |
* | --- |
* | "Last Name" |
*
* @param {Lastname1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const lastname1 = /** @type {((inputs?: Lastname1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lastname1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_lastname1(inputs)
	return de_lastname1(inputs)
});
export { lastname1 as "lastName" }